<div class="background"></div>
<div class="login">
  <div class="card">
    <form class="k-form k-form-md" [formGroup]="loginForm">
      <div class="form-field">
        <a href="https://www.autoform.com/" target="_blank" rel="noopener noreferrer">
          <div class="header">
            <img src="assets/logo-orginal.jpg"
               alt="Logo"
               class="logo">
          </div>
        </a>
        <div class="login-box">
          <div class="headline">
            <span>Sign in</span>
            <span>AutoForm Cloud</span>
          </div>
          <div>
              <div class="label-row">
                  <kendo-label [for]="email" text="Email"></kendo-label>
                      <input type="checkbox"
                             #remember
                             formControlName="remember"
                             kendoCheckBox />
                      <kendo-label
                              class="k-checkbox-label"
                              [for]="remember"
                              text="Remember me"
                      ></kendo-label>
              </div>
            <kendo-formfield>
              <kendo-textbox
                formControlName="username"
                #email
                required
                placeholder="name@company.com"
              ></kendo-textbox>
              <kendo-formerror>Please enter a valid email address</kendo-formerror>
            </kendo-formfield>

            @if(errorMessage) {
              <af-form-error
                [message]="errorMessage"
              ></af-form-error>
            }
          </div>
            <div>
            <kendo-formfield>
              <div class="checkbox-accept-terms">
                <input
                  type="checkbox"
                  formControlName="terms"
                  #terms
                  kendoCheckBox />
                <kendo-label
                  class="k-checkbox-label"
                  [for]="terms"
                >
                I have read and accept the
                <a href="../../../assets/AutoForm-Cloud_Terms-of-Use.pdf" target="_blank" rel="noopener noreferrer">
                  Terms of Use Agreement</a>
                  <span class="terms-additional-lines">and the
                    <a href="https://www.autoform.com/en/legal/#c3412" target="_blank" rel="noopener noreferrer">
                    Privacy Policy</a>.
                  </span>
                  <span class="terms-additional-lines">
                    By using our service, you agree to the use of essential cookies.
                  </span>
                </kendo-label>
              </div>
              <kendo-formerror>Acceptance of the Terms of Use Agreement and Privacy Policy is required.</kendo-formerror>
            </kendo-formfield>
            </div>

            <div class="k-form-buttons">
              <button kendoButton (click)="onSubmit()">
                Continue with email ->
              </button>
            </div>

            <div class="forgot-password">
                <span>Need help to Sign in? Contact the administrator</span>
            </div>
          </div>
        <div class="footer">
            <a href="https://www.autoform.com/{{translationService.getLanguage()}}/imprint/" target="_blank">Impressum</a>
            <span>&copy; {{date | date: 'yyyy'}} AutoForm Engineering GmbH</span>
        </div>
      </div>
    </form>
  </div>
</div>
